import _defineProperty from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { FormLabel } from '../FormLabel';
import { FormHelperText } from '../FormHelperText';
import { pickAriaProps, pickComponentCommonProps } from '../../interfaces/commonProps';
import { useSpacing } from '../../api/spacing/useSpacing';
import { StyledInput, StyledTextField, StyledInputWrapper, StyledExtension, StyledTextFieldLayout } from './TextField.styles';

var noop = function noop() {};

export var TextField = React.forwardRef(function (_ref, ref) {
  var autoComplete = _ref.autoComplete,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === void 0 ? false : _ref$invalid,
      hint = _ref.hint,
      extensionEnd = _ref.extensionEnd,
      id = _ref.id,
      inputId = _ref.inputId,
      inputMode = _ref.inputMode,
      inputRef = _ref.inputRef,
      label = _ref.label,
      _ref$labelEffect = _ref.labelEffect,
      labelEffect = _ref$labelEffect === void 0 ? 'float' : _ref$labelEffect,
      list = _ref.list,
      max = _ref.max,
      maxLength = _ref.maxLength,
      min = _ref.min,
      minLength = _ref.minLength,
      name = _ref.name,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? noop : _ref$onBlur,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? noop : _ref$onFocus,
      pattern = _ref.pattern,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      validationMessage = _ref.validationMessage,
      value = _ref.value,
      restProps = _objectWithoutProperties(_ref, ["autoComplete", "disabled", "invalid", "hint", "extensionEnd", "id", "inputId", "inputMode", "inputRef", "label", "labelEffect", "list", "max", "maxLength", "min", "minLength", "name", "onBlur", "onChange", "onFocus", "pattern", "readOnly", "required", "type", "validationMessage", "value"]);

  var hasStringExtension = typeof extensionEnd === 'string';
  var extensionEndId = "".concat(inputId, "__extension-end");
  var hintMessageId = "".concat(inputId, "__hint-message");
  var validationMessageId = "".concat(inputId, "__invalid-message");
  var ariaProps = pickAriaProps(restProps);
  var describedBy = [hasStringExtension ? extensionEndId : '', hint ? hintMessageId : '', invalid ? validationMessageId : '', ariaProps['aria-describedby'] || ''].join(' ').trim() || undefined;
  var extensionProps = {
    disabled: disabled,
    invalid: invalid,
    readOnly: readOnly
  };
  var extension = typeof extensionEnd === 'string' ? React.createElement(StyledExtension, _objectSpread({
    id: extensionEndId
  }, extensionProps), extensionEnd) : extensionEnd && React.cloneElement(React.Children.only(extensionEnd), extensionProps);
  return React.createElement(StyledTextField, _objectSpread({
    id: id,
    outerSpacing: useSpacing(restProps),
    ref: ref
  }, pickComponentCommonProps(restProps)), React.createElement(StyledTextFieldLayout, {
    hasExtensionEnd: Boolean(extensionEnd)
  }, React.createElement(StyledInputWrapper, {
    disabled: disabled,
    invalid: invalid,
    readOnly: readOnly
  }, React.createElement(FormLabel, {
    as: "label",
    disabled: disabled,
    variant: labelEffect,
    empty: !value,
    invalid: invalid,
    htmlFor: inputId,
    readOnly: readOnly,
    required: required
  }, label), React.createElement(StyledInput, _objectSpread({}, ariaProps, {
    autoComplete: autoComplete,
    "aria-describedby": describedBy,
    disabled: disabled,
    filled: Boolean(value === null || value === void 0 ? void 0 : value.length),
    id: inputId,
    inputMode: inputMode,
    list: list,
    max: max,
    maxLength: maxLength,
    min: min,
    minLength: minLength,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    pattern: pattern,
    readOnly: readOnly,
    ref: inputRef,
    required: required,
    type: type,
    value: value
  }))), extension), hint && React.createElement(FormHelperText, {
    id: hintMessageId,
    spaceStackStart: 's',
    variant: "hint"
  }, hint), invalid && validationMessage && React.createElement(FormHelperText, {
    id: validationMessageId,
    spaceStackStart: hint ? 'xxs' : 's',
    variant: "invalid"
  }, validationMessage));
});
TextField.displayName = 'TextField';